import { Dirf } from './dirf';
export class CedulaC {
  id: number = null;
  fkServidor: number = null;
  //dirf: Dirf = null;
  bbCedulaC: Blob = null;
  bbPreviaCedulaC: Blob = null;
  bbXml: Blob = null;
  temXml: string = 'N';
  previa: string = null;
  tipoCedulaC: string = null;
  nrAnoCalendario: number = null;
  snRetificadora: string = null;

  constructor(d?) {
    if (d) {
      this.id = d.id ? d.id : null;
      this.fkServidor = d.fkServidor ? d.fkServidor : null;
      //this.dirf = d.dirf ? new Dirf(d.dirf) : null;
      this.bbCedulaC = d.bbCedulaC ? d.bbCedulaC : null;
      this.bbPreviaCedulaC = d.bbPreviaCedulaC ? d.bbPreviaCedulaC : null;
      this.bbXml = d.bbXml ? d.bbXml : null;
      this.temXml = d.temXml ? d.temXml : null;
      this.previa = d.previa ? d.previa : null;
      this.tipoCedulaC = d.tipoCedulaC ? d.tipoCedulaC : null;
      this.nrAnoCalendario = d.nrAnoCalendario ? d.nrAnoCalendario : null;
      this.snRetificadora = d.snRetificadora ? d.snRetificadora : null;
    }
  }

  documentoValido(): Blob {
    if (this.bbCedulaC) {
      return this.bbCedulaC;
    } else {
      return this.bbPreviaCedulaC;
    }
  }

  nomeArquivo(nome?: string, pExtensao?: string): string {
    let nomeAux: string = '';

    if (nome) {
      nomeAux = nome;
    }

    //console.log('nome', nome);
    //console.log('pExtensao', pExtensao);
    return (
      nomeAux +
      'Comprovante_rendimentos_' +
      this.nrAnoCalendario +
      '(' +
      this.fkServidor +
      //'-' + this.dirf.dsIdLayout +
      ').' +
      pExtensao
    );
  }
}
